import NProgress from 'nprogress';
import Router from 'next/router';
import { debounce } from 'lodash';

import { css } from '@emotion/core';

export const nprogressStyles = css`
  #nprogress {
    pointer-events: none;
  }
  #nprogress .bar {
    background-color: #ff4a00;
    position: fixed;
    z-index: 1031;
    top: 0;
    left: 0;
    width: 100%;
    height: 2px;
  }
  #nprogress .peg {
    display: block;
    position: absolute;
    right: 0;
    width: 100px;
    height: 100%;
    box-shadow: 0 0 10px #29d, 0 0 5px #29d;
    opacity: 1;
    transform: rotate(3deg) translateY(-4px);
  }
  #nprogress .spinner-icon {
    width: 18px;
    height: 18px;
    box-sizing: border-box;
    border-color: #29d transparent transparent #29d;
    border-style: solid;
    border-width: 2px;
    border-radius: 50%;
    animation: nprogress-spinner 0.4s linear infinite;
  }
  .nprogress-custom-parent {
    overflow: hidden;
    position: relative;
  }
  .nprogress-custom-parent #nprogress .bar,
  .nprogress-custom-parent #nprogress .spinner {
    position: absolute;
  }
  @keyframes nprogress-spinner {
    0% {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(1turn);
    }
  }
`;

export const initializeNprogress = () => {
  const start = debounce(NProgress.start, 200);

  Router.onRouteChangeStart = () => {
    start();
  };

  Router.onRouteChangeComplete = () => {
    start.cancel();
    NProgress.done();
  };

  Router.onRouteChangeError = () => {
    start.cancel();
    NProgress.done();
  };
};
